import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaCoins, FaRegUserCircle } from 'react-icons/fa';
import axios from 'axios';

import { API_SERVER } from '../../../../config/constant';

import { ConfigContext } from '../../../../contexts/ConfigContext';
import * as actionType from '../../../../store/actions';
import logo from '../../../../assets/images/stockist-logo.png';

const NavLogo = () => {
    const configContext = useContext(ConfigContext);
    const { collapseMenu } = configContext.state;
    const { dispatch } = configContext;
    const [stockistBalance, setStockistBalance] = useState(null);
    const [stockistName, setStockistName] = useState(null);

    const account = useSelector((state) => state.account);
    const dispatcher = useDispatch();


    let toggleClass = ['mobile-menu'];
    if (collapseMenu) {
        toggleClass = [...toggleClass, 'on'];
    }

    return (
        <React.Fragment>
            <div className="navbar-brand header-logo">
                <Link to="/dashboard" className="b-brand">
                    <img className="admin-logo" src={logo} alt="admin logo" />
                    <span className="b-title">Klinik Doctor</span>
                </Link>
            </div>
        </React.Fragment>
    );
};

export default NavLogo;
